<template>
  <section>
    <div class="row">
      <div
        id="loadingmessage"
        style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;"
        v-if="loading"
      >
        <p style="position: absolute; color: White; top: 40%; left: 50%;">
          <img src="../../assets/loader.gif" />
        </p>
      </div>
      <div class="col-12 grid-margin">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Add a Rescue Center</h4>
            <form class="form-sample" @submit="onSubmit">
              <div class="row">
                <div class="col-md-6">
                  <b-form-group horizontal label="Name">
                    <b-form-input required type="text" v-model="name"></b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-6">
                  <b-form-group horizontal label="Phone">
                    <b-form-input required type="number" maxlength="10" v-model="phone"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group horizontal label="Email">
                    <b-form-input required type="email" v-model="email"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group horizontal label="HTTP Link">
                    <b-form-input type="text" v-model="link"></b-form-input>
                  </b-form-group>

                  <!-- <p id="GFG_UP" style="font-size: 15px;  
                          font-weight: bold;"> 
    </p> 
     <p id="GFG_DOWN" style="color:green; 
                            font-size: 20px;  
                            font-weight: bold;"> 
     </p>
                  -->
                </div>
                <div class="col-md-6">
                  <b-form-group horizontal label="Address">
                    <b-form-textarea id="textarea5" v-model="address" rows="5"></b-form-textarea>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group horizontal label="State">
                    <b-form-input required type="text" v-model="state"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group horizontal label="Comments">
                    <b-form-input  type="text" v-model="comment"></b-form-input>
                  </b-form-group>
                </div>
              </div>

              <label for="exampleInputEmail1" style="font-size:20px!important">Please Add Location</label>

               <div class="input-group-prepend">
                <br />
               <div class="col-md-6">
                <input
                  name="lat"
                  type="text"
                  v-model="lat"
                  class="form-control"
                  placeholder="Please Enter Latitude"
                  required
                />
               </div>
                <br />
                 <div class="col-md-6">
                <input
                  name="lon"
                  type="text"
                  v-model="lon"
                  ref="myLngField"
                  placeholder="Please Enter Longitude"
                  class="form-control"
                  required
                />
                 </div>
              </div>
            
              <br>
               
      
                <div id="myMap"></div>
              <br />

              <b-button variant="primary" class="btn-fw" type="submit">Submit</b-button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
  
  <script>
import axios from "axios";
export default {
  name: "addaturtle",
  props: {
    caption: {
      type: String,
      default: "Add a Turtle"
    }
  },
  data: () => {
    return {
      email: "",
      address: "",
      link: "",
      loading: false,
      lat: null,
      lon: null,
      name: "",
      phone: "",
      state: "",
      res: "",
      comment: "",
      click: false
    };
  },

  mounted: function() {
    this.getListClick();
    this.getList();
  },

  watch: {
    lat: function() {
      this.getList();
        this.getListClick();
    },
    lon: function() {
      this.getList();
        this.getListClick();
    }
  },
  methods: {
    resetForm() {
      this.link = "";
      this.address = "";
      this.email = "";
      this.lat = null;
      this.lon = null;
      this.name = "";
      this.state = "";
      this.phone = "";
    },
    getListClick() {
      var marker = 1;
      var vm = this;
      var centerOfMap = new google.maps.LatLng(10.030551, 76.524354);
      var options = {
        zoom: 4,
        center: centerOfMap,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        mapTypeControl: false
      };
      var map = new google.maps.Map(document.getElementById("myMap"), options);
      var latlngset = new google.maps.LatLng(this.lat, this.lon);

      marker = new google.maps.Marker({
        map: map,
        position: latlngset
      });

      marker.setPosition(latlngset);

      google.maps.event.addListener(map, "click", function(event) {
        this.click = true;
        var clickedLocation = event.latLng;

        if (marker == 1) {
          marker = new google.maps.Marker({
            position: clickedLocation,
            map: map,
            draggable: true
          });
          google.maps.event.addListener(marker, "dragend", function(event) {
            vm.markerLocation(marker);
          });
        } else {
          marker.setPosition(clickedLocation);
        }

        //Get the marker's location.
        vm.markerLocation(marker);
      });
    },
    getList() {
      var marker = 1;
      var vm = this;
      var centerOfMap = new google.maps.LatLng(10.030551, 76.524354);
      var options = {
        zoom: 4,
        center: centerOfMap,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        mapTypeControl: false
      };
      var map = new google.maps.Map(document.getElementById("myMap"), options);
      var latlngset = new google.maps.LatLng(this.lat, this.lon);

      marker = new google.maps.Marker({
        map: map,
        position: latlngset
      });

      marker.setPosition(latlngset);

      google.maps.event.addListener(map, "click", function(event) {
        //Get the marker's location.
        vm.markerLocation(marker);
      });
    },

    markerLocation(marker) {
      var currentLocation = marker.getPosition();
      this.lat = currentLocation.lat(); //latitude
      this.lon = currentLocation.lng(); //longitude
    },
    onSubmit(evt) {
      evt.preventDefault();
      var add = {};
      // var el_up = document.getElementById("GFG_UP");
      // var el_down = document.getElementById("GFG_DOWN");
      // var expression = /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi;
      // var regex = new RegExp(expression);
      // var url = this.link;
      // el_up.innerHTML = "URL = '" + url + "'";
      add["address"] = this.address;
      add["email"] = this.email;
      add["link"] = this.link;
      add["lat"] = this.lat;
      add["lon"] = this.lon;
      add["name"] = this.name;
      add["state"] = this.state;
      add["phone"] = this.phone;
      add["comment"] = this.comment;

      add["x-auth-token"] = localStorage.getItem("token");

      axios({
        method: "post",
        url: "/rescue/add",
        data: add
      })
        .then(response => {
          this.msg = response.data.msg;
          this.id = response.data._id;
          this.loading = "false";
          if (response.data.status === true) {
            this.loading = false;
            // this.resetForm();
            alert("Added Successfully ");
            this.$router.push({ path: "/rescueCentersList" });
          }
          if (response.data.status === false) {
            this.loading = false;

            alert("Please try again");
          }
        })
        .catch(err => {
          this.loading = false;

          alert("Please try again");
        });
    },

    gfg_Run() {
      var res = "";
      if (url.match(regex)) {
        this.res = "Valid URL";
      } else {
        this.res = "Invalid URL";
      }
      el_down.innerHTML = res;
    }
  }
};
</script>
  
  <style>
#myMap {
  height: 600px !important;
  width: 100%;
}
</style>